"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguagePicker = void 0;
const language_picker_html_1 = __importDefault(require("./templates/language-picker.html"));
const locales_1 = require("../locales");
/**
 * Language switcher.
 *
 * This used to hold the whole translation table and rewrite every
 * [data-translate] element in place, keeping the URL unchanged. That was
 * invisible to search engines: one URL, one indexed language, and the entire
 * Italian site — including the full privacy policy and terms — shipped as dead
 * weight in the JS bundle.
 *
 * Translation now happens at build time, one static HTML file per language
 * under its own /<lang>/ prefix. All this component has to do is navigate to
 * the current page's equivalent in the chosen language, which is also exactly
 * what the rel="alternate" hreflang links in the head advertise.
 */
class LanguagePicker {
    element;
    isNewsPage;
    constructor(isNewsPage) {
        this.isNewsPage = isNewsPage;
        this.element = this.createPicker();
        this.initializeLanguage();
        this.setupEventListeners();
    }
    /**
     * The locale of the page being displayed. The URL prefix is authoritative —
     * it is what the server routed on and what the build stamped into the
     * document — with <html lang> as a fallback for anything served outside the
     * normal routing (e.g. the dev server's directory listing).
     */
    currentLocale() {
        const fromPath = (0, locales_1.localeFromPath)(window.location.pathname);
        if (fromPath)
            return fromPath;
        const fromDocument = document.documentElement.lang;
        return (0, locales_1.isLocale)(fromDocument) ? fromDocument : locales_1.DEFAULT_LOCALE;
    }
    createPicker() {
        const container = document.querySelector('.language-picker');
        if (!container)
            throw new Error('Language picker container not found');
        // News posts are written in English only, so there is nothing to switch to
        // there and the picker collapses to a single, disabled option.
        const languages = this.isNewsPage ? [locales_1.NEWS_LOCALE] : locales_1.LOCALES;
        const itemTemplate = language_picker_html_1.default.match(/{{#each languages}}(.*?){{\/each}}/s)[1];
        const processedTemplate = language_picker_html_1.default.replace(/{{#each languages}}(.*?){{\/each}}/s, languages.map((code) => itemTemplate.replace(/{{code}}/g, code).replace(/{{name}}/g, locales_1.LANGUAGE_NAMES[code])).join(''));
        container.innerHTML = processedTemplate;
        return container.querySelector('select');
    }
    initializeLanguage() {
        this.element.value = this.currentLocale();
        if (this.isNewsPage) {
            this.element.disabled = true;
            return;
        }
        // Optional chaining: if the analytics script is blocked (ad blockers) or slow
        // to load, window.umami is undefined — tracking must never break the site.
        window.umami?.track('Language', { language: this.element.value });
    }
    setupEventListeners() {
        this.element.addEventListener('change', (e) => this.updateLanguage(e));
    }
    updateLanguage(e) {
        const target = e.target;
        if (!(0, locales_1.isLocale)(target.value))
            return;
        window.umami?.track('Language Changed', { language: target.value });
        // Deliberately no localStorage: the URL is the only source of truth for the
        // language. Silently redirecting a visitor (or a crawler) away from the URL
        // they requested because of a stored preference is precisely what breaks
        // per-language indexing.
        window.location.href = (0, locales_1.switchLocale)(window.location.pathname, target.value) + window.location.search + window.location.hash;
    }
}
exports.LanguagePicker = LanguagePicker;
